module.exports = __webpack_public_path__ + "static/media/spinner.14961e0a.svg";